import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { enablePwaAutoUpdater } from "./pwa-updater"; // Uncommented

// Enable PWA auto-updater
enablePwaAutoUpdater(); // Uncommented

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {(() => {
      const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as
        | string
        | undefined;
      if (!clientId) {
        console.error(
          "VITE_GOOGLE_CLIENT_ID is not set. Google login will be disabled."
        );
        return (
          <Provider store={store}>
            <App />
          </Provider>
        );
      }
      return (
        <GoogleOAuthProvider clientId={clientId}>
          <Provider store={store}>
            <App />
          </Provider>
        </GoogleOAuthProvider>
      );
    })()}
  </React.StrictMode>
);
